import { InjectionToken } from '@angular/core';
import { AppSettings } from 'src/app.settings';

export const SERVER_APP_SETTINGS = new InjectionToken<AppSettings>('SERVER_APP_SETTINGS');
